import { c as _c } from "react-compiler-runtime";
// per-subtree locale state, separate from the global I18n singleton
//
// the lib's preview modal will eventually have a language dropdown that
// flips the rendered locale just inside the modal, but calling
// I18n.setLocale would also flip the rest of the sender's app which is
// wrong
//
// useActiveLocale falls back to getLangLocale when no provider is mounted
// so cards still work in the kitchen-sink demo and in jasmine specs

import { createContext, useContext, useState } from 'react';
import getLangLocale from 'I18n/utils/getLangLocale';
import { jsx as _jsx } from "react/jsx-runtime";
const LocaleContext = /*#__PURE__*/createContext(null);
export const LocaleProvider = t0 => {
  const $ = _c(7);
  const {
    initialLocale,
    children
  } = t0;
  let t1;
  if ($[0] !== initialLocale) {
    t1 = () => initialLocale !== null && initialLocale !== void 0 ? initialLocale : getLangLocale();
    $[0] = initialLocale;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const [locale, setLocale] = useState(t1);
  let t2;
  if ($[2] !== locale) {
    t2 = {
      locale,
      setLocale
    };
    $[2] = locale;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== children || $[5] !== t2) {
    t3 = /*#__PURE__*/_jsx(LocaleContext.Provider, {
      value: t2,
      children: children
    });
    $[4] = children;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};
export const useActiveLocale = () => {
  const $ = _c(1);
  const ctx = useContext(LocaleContext);
  if (ctx) {
    return ctx.locale;
  }
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = getLangLocale();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
const noop = __locale => {};
export const useSetActiveLocale = () => {
  const ctx = useContext(LocaleContext);
  if (ctx) {
    return ctx.setLocale;
  }
  return noop;
};